import * as React from "react";
import { FunctionComponent, useState, useEffect } from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import { AutoClaimReport, ClaimType } from "../../../Models/Claim";
import { Collapse } from "react-bootstrap";
import { ValidateEmail } from "../../../Utils";
interface StepOneProps {
	progressBack: () => void;
	nextStep: (step: number, claim: AutoClaimReport, validate: boolean) => void;
	claim: AutoClaimReport;
	showError: boolean;
}

export const StepOne: FunctionComponent<StepOneProps> = ({ progressBack, nextStep, claim, showError }) => {
	const [width, setWidth] = useState<number>(window.innerWidth);
	const [firstLoad, setFirstLoad] = useState<boolean>(true);
	const [lossLocation, setLossLocation] = useState<string>(claim.lossLocation);
	const [street, setStreet] = useState<string>(claim.line1);
	const [city, setCity] = useState<string>(claim.city);
	const [state, setState] = useState<string>(claim.state);
	const [zip, setZip] = useState<string>(claim.zipCode);
	const [policyHolderName, setPolicyHolderName] = useState<string>(claim.policyName);
	const [policyHolderPhone, setPolicyHolderPhone] = useState<string>(claim.primaryPhone);
	const [policyHolderAltPhone, setPolicyHolderAltPhone] = useState<string>(claim.altPhone);
	const [policyHolderEmail, setPolicyHolderEmail] = useState<string>(claim.email);
	const [claimRelation, setClaimRelation] = useState<string>(claim.additionalAnswers["altContactRelation"] || "");
	const [claimRelationName, setClaimRelationName] = useState<string>(claim.additionalAnswers["altContactName"] || "");
	const [claimRelationPhone, setClaimRelationPhone] = useState<string>(claim.additionalAnswers["altContactPhone"] || "");
	const [claimRelationEmail, setClaimRelationEmail] = useState<string>(claim.additionalAnswers["altContactEmail"] || "");
	const [bestContact, setBestContact] = useState<string>(localStorage.getItem("autoclaim-bestcontact") || "");
	const [bestContactName, setBestContactName] = useState<string>(claim.bestContactName);
	const [bestContactPhone, setBestContactPhone] = useState<string>(claim.bestContactPhone);
	const [bestContactAltPhone, setBestContactAltPhone] = useState<string>(claim.bestContactAltPhone);

	useEffect(() => {
		if (firstLoad) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			setFirstLoad(false);
		}
	}, [firstLoad])

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}


	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		}
	}, []);

	

	let isMobile: boolean = (width <= 768);
	return <div>
		<div className="step-one">
			<div className="form-group">
				<p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">Where did the loss occur (list street as N/A if not known)<span className="red-ast">*</span>?</p>
			</div>
			<div className="form-group">
				<div className="col-lg-5 col-md-11 col-sm-12 col-xs-11 mobile-padding-down">
					<label htmlFor="policy-street" className="sr-only">Policy location Street Name required</label>
					<input type="text" id="policy-street" maxLength={45} aria-invalid={showError && street === ""} aria-required aria-describedby="streetError" name="Policy location street name" className="form-control" placeholder="Street" value={street} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setStreet(e.target.value);
					}} />
					<p id="streetError" className={showError && street === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
				<div className="col-lg-3 col-md-5 col-sm-4 col-xs-4">
					<label htmlFor="policy-city" className="sr-only">Policy location city required</label>
					<input type="text" id="policy-city" maxLength={30} aria-invalid={showError && city === ""} aria-required aria-describedby="cityError" name="Policy location city" className="form-control" placeholder="City" value={city} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setCity(e.target.value);
					}} />
					<p id="cityError" className={showError && city === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
				<div className="col-lg-2 col-md-3 col-sm-3 col-xs-3">
					<label htmlFor="policy-state" className="sr-only">Policy Location state required</label>
					<input type="text" id="policy-state" aria-invalid={showError && state === ""} aria-required aria-describedby="stateError" name="Policy Location state" className="form-control" placeholder="State" maxLength={2} value={state} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setState(e.target.value);
					}} />
					<p id="stateError" className={showError && state === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
				<div className="col-lg-2 col-sm-4 col-md-4 col-xs-4">
					<label htmlFor="policy-zip" className="sr-only">Policy location zipcode required</label>
					<input type="text" inputMode="numeric" aria-invalid={showError && zip === ""} aria-required aria-describedby="zipError" pattern="[0-9]*" id="policy-zip" name="Policy location zipcode" className="form-control" placeholder="Zipcode" maxLength={5} value={zip} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setZip(e.target.value.replace(/\D/g, ''));
					}} />
					<p id="zipError" className={showError && zip === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="loss-location">Describe the location if street is unavailable or specific location</label>
				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<textarea className="form-control" id="loss-location" aria-describedby="lossLocationCount" placeholder="shopping center parking lot" maxLength={70} value={lossLocation} rows={3} name="Loss Location" onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
						setLossLocation(e.target.value.toLocaleLowerCase());
					}} />
					<p id="lossLocationCount"><strong>Max allowed 70 characters.  You have used {lossLocation.length} characters.</strong></p>
				</div>
			</div>

			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="policy-name">Policyholder's name<span className="red-ast">*</span>:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={35} id="policy-name" aria-invalid={showError && policyHolderName === ""} aria-required aria-describedby="policyHolderNameError" placeholder="John Smith" name="Policy Holder's Name" value={policyHolderName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPolicyHolderName(e.target.value);
					}} />
					<p id="policyHolderNameError" className={showError && policyHolderName === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="policy-phone">Policyholder's phone number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="policy-phone" aria-invalid={showError && (policyHolderPhone !== "" && !isValidPhoneNumber(policyHolderPhone))} aria-describedby="primaryPhoneError" className="form-control" placeholder="(123)-456-7890" name="Policy Holder Primary Phone" country="US" international={false} value={policyHolderPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setPolicyHolderPhone(phone);
					}} />
					<p id="primaryPhoneError" className={showError && (policyHolderPhone !== "" && !isValidPhoneNumber(policyHolderPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="policy-altphone">Policyholder's alternate phone number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="policy-altphone" aria-invalid={showError && (policyHolderAltPhone !== "" && !isValidPhoneNumber(policyHolderAltPhone))} aria-required aria-describedby="altPhoneError" className="form-control" placeholder="(123)-456-7890" name="Policy Holder Altnerate Phone" country="US" international={false} value={policyHolderAltPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setPolicyHolderAltPhone(phone);
					}} />
					<p id="altPhoneError" className={showError && (policyHolderAltPhone !== "" && !isValidPhoneNumber(policyHolderAltPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="policy-email">Policyholder's Email:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-invalid={showError && policyHolderEmail !== "" && !ValidateEmail(policyHolderEmail)} aria-describedby="mainEmailError" id="policy-email" placeholder="jsmith@domain.com" name="Policy Holder's Email" value={policyHolderEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPolicyHolderEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="mainEmailError" className={showError && (policyHolderEmail !== "" && !ValidateEmail(policyHolderEmail)) ? "error" : "error-hidden"}>Please provide a valid email</p>
				</div>
			</div>
			<div className="form-group">
				<label htmlFor="relation-type" className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12">Your relation to claim<span className="red-ast">*</span>:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<select className="form-control" id="relation-type" aria-invalid={showError && claimRelation === ""} aria-required aria-describedby="claimRelationError" name="Relation to policy holder" value={claimRelation} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
						setClaimRelation(e.target.value);
                        if (e.target.value === "Policyholder")
                        {
                            setClaimRelationName(policyHolderName);
                            policyHolderPhone !== "" ? setClaimRelationPhone(policyHolderPhone) : null;
                            policyHolderEmail !== "" ? setClaimRelationEmail(policyHolderEmail) : null;
                        }
                        else if (claimRelation === "Policyholder")
                        {
                            setClaimRelationName("");
                            setClaimRelationPhone("");
                            setClaimRelationEmail("");
                        }
					}}>
						<option value="">Select...</option>
						<option value="Policyholder">Policyholder</option>
						<option value="Agent">Agent</option>
						<option value="Other Involved Party">Other Involved Party</option>
						<option value="Relative">Relative</option>
						<option value="Attorney">Attorney</option>
						<option value="Other">Other</option>
					</select>
					<p id="claimRelationError" className={showError && claimRelation === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="claim-relation-name">Your Name<span className="red-ast">*</span>:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={35} aria-invalid={showError && claimRelationName === ""} aria-required aria-describedby="claimRelationNameError" id="claim-relation-name" placeholder="John Smith" name="Claim Relation's Name" value={claimRelationName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setClaimRelationName(e.target.value);
					}} />
					<p id="claimRelationNameError" className={showError && claimRelationName === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="claim-relation-phone">Your Number<span className="red-ast">*</span>:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="claim-relation-phone" aria-invalid={showError && ((claimRelationPhone === "") || (claimRelationPhone !== "" && !isValidPhoneNumber(claimRelationPhone)))} aria-required aria-describedby="yourPhoneError" className="form-control" placeholder="(123)-456-7890" name="Claim Relation's Phone" country="US" international={false} value={claimRelationPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setClaimRelationPhone(phone);
					}} />
					<p id="yourPhoneError" className={showError && ((claimRelationPhone === "") || (claimRelationPhone !== "" && !isValidPhoneNumber(claimRelationPhone))) ? "error" : "error-hidden"}>
						{claimRelationPhone !== "" && !isValidPhoneNumber(claimRelationPhone) ? "Please provide a valid phone number" : "This field is required"}</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="claim-relation-email">Your Email<span className="red-ast">*</span>:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-required  aria-invalid={showError && (claimRelationEmail === "" ||(claimRelationEmail !== "" && !ValidateEmail(claimRelationEmail)))} aria-describedby="claimEmailError" id="claim-relation-email" placeholder="jsmith@domain.com" name="Claim Relatin's Email" value={claimRelationEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setClaimRelationEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="claimEmailError" className={showError && (claimRelationEmail === "" ||(claimRelationEmail !== "" && !ValidateEmail(claimRelationEmail))) ? "error" : "error-hidden"}>{claimRelationEmail === "" ? "This field is required" : "Please provide a valid email"}</p>
				</div>
			</div>
			<div className="form-group">
				<label htmlFor="claim-best-contact" className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12">Who is the best person to contact for this claim<span className="red-ast">*</span>:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<select className="form-control" id="claim-best-contact" aria-invalid={showError && bestContact === ""} aria-required aria-describedby="bestContactError" name="Claim Best Contact" value={bestContact} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
						setBestContact(e.target.value);
						autoFillValues(e.target.value, false);
						localStorage.setItem("autoclaim-bestcontact", e.target.value)
					}}>
						<option value="">Select...</option>
						<option value="Policyholder">Policyholder</option>
						<option value="Other">Other</option>
					</select>
					<p id="bestContactError" className={showError && bestContact === "" ? "error" : "error-hidden"}>This field is required</p>
				</div>
			</div>

			<Collapse in={bestContact === "Other" ? true : false}>
				<div className="best-contact-popup">
					<div className="form-group">
						<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="best-contact-name">Best Contact Name<span className="red-ast">*</span>:</label>
						<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<input className="form-control" maxLength={35} aria-invalid={showError && bestContact === "Other" && bestContactName === ""} aria-required={bestContact === "Other"} aria-describedby="bestContactNameError" type="text" id="best-contact-name" placeholder="John Smith" name="Best Contact's Name" value={bestContactName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								setBestContactName(e.target.value);
							}} />
							<p id="bestContactNameError" className={showError && bestContact === "Other" && bestContactName === "" ? "error" : "error-hidden"}>This field is required</p>
						</div>
					</div>
					<div className="form-group">
						<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="best-contact-phone">Best Contact Number<span className="red-ast">*</span>:</label>
						<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<PhoneInput className="form-control" aria-invalid={showError && bestContact === "Other" && ((bestContactPhone === "") || (bestContactPhone !== "" && !isValidPhoneNumber(bestContactPhone)))} aria-required={bestContact === "Other"} aria-describedby="bestPhoneError" id="best-contact-phone" placeholder="(123)-456-7890" name="Best Contact's Phone" country="US" international={false} value={bestContactPhone} maxLength={14} onChange={(phone: string) => {
								if (!phone) phone = "";
								setBestContactPhone(phone);
							}} />
							<p id="bestPhoneError" className={showError && bestContact === "Other" && ((bestContactPhone === "") || (bestContactPhone !== "" && !isValidPhoneNumber(bestContactPhone))) ? "error" : "error-hidden"}>
								{bestContactPhone !== "" && !isValidPhoneNumber(bestContactPhone) ? "Please provide a valid phone number" : "This field is required"}</p>
						</div>
					</div>
					<div className="form-group">
						<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="best-contact-altphone">Best Contact Alternate Number:</label>
						<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<PhoneInput className="form-control" aria-invalid={showError && bestContact === "Other" && (bestContactAltPhone !== "" && !isValidPhoneNumber(bestContactAltPhone))} aria-describedby="bestAltPhoneError" id="best-contact-altphone" placeholder="(123)-456-7890" name="Best Contact's Alternate Phone" country="US" international={false} value={bestContactAltPhone} maxLength={14} onChange={(phone: string) => {
								if (!phone) phone = "";
								setBestContactAltPhone(phone);
							}} />
							<p id="bestAltPhoneError" className={showError && bestContact === "Other" && (bestContactAltPhone !== "" && !isValidPhoneNumber(bestContactAltPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
						</div>
					</div>
				</div>
			</Collapse>

			<div className="form-group button-group">
				<button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { localStorage.removeItem("autoclaim-bestcontact"); progressBack(); }}><i className="fa fa-arrow-left" aria-hidden="true" />&nbsp;BACK</button>
				<button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goForward(3); }}><i className="fa fa-arrow-right" aria-hidden="true" />&nbsp;NEXT</button>
                {showError ? <button className="btn btn-warning" type="button" onClick={() => { goForward(5, true); }}><i className="fa fa-fast-forward" aria-hidden="true" />&nbsp;Step 5</button> : null}
			</div>
		</div>
	</div>;

	function autoFillValues(relation: string, forward: boolean) {
		if (relation === "Other" && !forward) {
			setBestContactName("");
			setBestContactPhone("");
			setBestContactAltPhone("");
		}
		else if (relation === "Policyholder") {
			setBestContactName(policyHolderName);
			setBestContactPhone(policyHolderPhone);
			setBestContactAltPhone(policyHolderAltPhone);
		}
	}

	function goForward(step: number, validate:boolean = false) {
		autoFillValues(bestContact, true);
		claim.lossLocation = lossLocation;
		claim.line1 = street;
		claim.city = city;
		claim.state = state;
		claim.zipCode = zip;
		claim.policyName = policyHolderName;
		claim.primaryPhone = policyHolderPhone;
		claim.altPhone = policyHolderAltPhone;
		claim.email = policyHolderEmail;
		claim.additionalAnswers["altContactRelation"] = claimRelation;
		let relationName = claimRelationName;
		let relationPhone = claimRelationPhone;
		let relationEmail = claimRelationEmail;
		if (claimRelation === "Policyholder")
		{
			relationPhone = policyHolderPhone === "" ? relationPhone : policyHolderPhone;
			relationEmail = policyHolderEmail === "" ? relationEmail : policyHolderEmail;
		}
		claim.additionalAnswers["altContactName"] = relationName;
		claim.additionalAnswers["altContactPhone"] = relationPhone;
		claim.additionalAnswers["altContactEmail"] = relationEmail;
		claim.bestContactName = bestContact === "Policyholder" ? policyHolderName : bestContactName;
		claim.bestContactPhone = bestContact === "Policyholder" ? policyHolderPhone : bestContactPhone;
		claim.bestContactAltPhone = bestContact === "Policyholder" ? policyHolderAltPhone : bestContactAltPhone;
		nextStep(step, claim, validate);
	}
}
